import React, { useEffect, useState } from "react";

const PrintLoader = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleToggle = (e) => {
      setLoading(!!e.detail);
    };

    window.addEventListener("show-print-loader", handleToggle);
    return () => window.removeEventListener("show-print-loader", handleToggle);
  }, []);

  if (!loading) return null;

  return (
    <div className="print-loading-overlay">
      <div className="print-loading-card">
        <div className="print-loading-spinner"></div>
        <div className="print-loading-title">Generating PDF</div>
        <div className="print-loading-text">Preparing your document. Please wait...</div>
      </div>
    </div>
  );
};

export default PrintLoader;
